const CodeEditorToolbar = require('./code-editor-toolbar.js')
const GameToolbar = require('./game-toolbar.js')

module.exports = function Toolbar (state, emit) {
  if (state.glitchEditorOpen) {
    return CodeEditorToolbar(state, emit)
  }
  return GameToolbar(state, emit)
}
